<button
  mat-icon-button
  type="button"
  class="fh-refresh-button"
  [matTooltip]="label()"
  [attr.aria-label]="label()"
  [disabled]="appStateService.isRefreshing()"
  (click)="refresh()"
>
  <mat-icon [class.fh-refresh-button-spinning]="appStateService.isRefreshing()">refresh</mat-icon>
</button>
